<template>
  <div class="container" ref="mapDiv">
    <div ref="toolbar" class="esri-widget esri-component custom-toolbar" style="background-color: transparent;"></div>
  </div>
</template>

<script>
import { loadModules } from 'esri-loader';

export default {
  props: {
    projectData: {
      type: Object,
      default: () => ({}),
    },
  },
  name: 'Map4Autoreport',
  data() {
    return {
      map: null,
      view: null,
      resData: null,
      PictureMarkerSymbol: null,
      Graphic: null,
      rainLayer: null,
      selectedHour: '24',

      greenMarkpic: require('@/assets/imgur/YFM5Dy8.png'),
      redMarkpic: require('@/assets/imgur/1ZgpXEY.png'),
      yellowMarkpic: require('@/assets/imgur/pwS4LcL.png'),
      geryMarkpic: require('@/assets/imgur/CDr09FQ.png'),

      locations: [
        { id: 'TK28+489', lat: 25.045541, lon: 121.328978, status: 'GREEN'},
        { id: 'TK31+784', lat: 25.058802, lon: 121.29953, status: 'GREEN'},
        { id: 'TK66+215', lat: 24.865008, lon: 121.055469, status: 'GREEN'},
        { id: 'TK70+730', lat: 24.840836, lon: 121.043438, status: 'GREEN'},
        { id: 'TK77+533', lat: 24.806539, lon: 121.027912, status: 'GREEN'},
        { id: 'TK78+551', lat: 24.783855, lon: 121.022813, status: 'GREEN'},
        { id: 'TK81+358', lat: 24.771875, lon: 121.001551, status: 'GREEN'},
        { id: 'TK83+585', lat: 24.756861, lon: 120.982448, status: 'GREEN'},
        { id: 'TK86+400', lat: 24.74293, lon: 120.959688, status: 'GREEN'},
        { id: 'TK88+298', lat: 24.721568, lon: 120.945465, status: 'GREEN'},
        { id: 'TK93+100', lat: 24.714818, lon: 120.919359, status: 'GREEN'},
        { id: 'TK93+500', lat: 24.691449, lon: 120.915552, status: 'GREEN'},
        { id: 'TK93+800', lat: 24.669592, lon: 120.913558, status: 'GREEN'},
        { id: 'TK96+942', lat: 24.654929, lon: 120.893997, status: 'GREEN'},
        { id: 'TK98+832', lat: 24.63084, lon: 120.877514, status: 'GREEN'},
        { id: 'TK99+815', lat: 24.615938, lon: 120.851343, status: 'GREEN'},
        { id: 'TK100+438', lat: 24.59448, lon: 120.825503, status: 'GREEN'},
        { id: 'TK107+180', lat: 24.576511, lon: 120.80509, status: 'GREEN'},
        { id: 'TK117+501', lat: 24.529675, lon: 120.748129, status: 'GREEN'},
        { id: 'TK118+763', lat: 24.50968, lon: 120.73296, status: 'GREEN'},
        { id: 'TK123+611', lat: 24.48815, lon: 120.710359, status: 'GREEN'},
        { id: 'TK125+846', lat: 24.463813, lon: 120.703528, status: 'GREEN'},
        { id: 'TK126+285', lat: 24.441764, lon: 120.702152, status: 'GREEN'},
        { id: 'TK147+112', lat: 24.27148, lon: 120.662476, status: 'GREEN'},
        { id: 'TK171+959', lat: 24.056395, lon: 120.606527, status: 'GREEN'},
        { id: 'TK172+801', lat: 24.028986, lon: 120.60442, status: 'GREEN'},
      ],
      locationMap: {},
    };
  },
  async mounted() {
    this.resData = this.projectData;
    this.locations.forEach(loc => {
      this.locationMap[loc.id] = loc;
    });

    const option = {
      url: 'https://js.arcgis.com/4.28/init.js',
      css: 'https://js.arcgis.com/4.28/esri/themes/light/main.css',
    };

    // ESRI 模塊
    const [Map, MapView, Graphic, PictureMarkerSymbol, BaseDynamicLayer] = await loadModules([
      'esri/Map',
      'esri/views/MapView',
      'esri/Graphic',
      'esri/symbols/PictureMarkerSymbol',
      'esri/layers/BaseDynamicLayer',
    ], option);

    this.Graphic = Graphic;
    this.PictureMarkerSymbol = PictureMarkerSymbol;

    // 創建地圖
    this.map = new Map({
      basemap: 'topo-vector',
      layers: [],
    });

    // 創建地圖視圖
    this.view = new MapView({
      container: this.$refs.mapDiv,
      map: this.map,
      zoom: 8,
      center: [121.186619, 23.649756],
      constraints: {
        rotationEnabled: false,
        maxZoom: 18,
      },
    });

    // 當地圖載入後，加入累積雨量圖層
    this.view.when(() => {
      this.addRainLayer(BaseDynamicLayer);
    });

    this.view.on('mouse-wheel', event => event.stopPropagation());
    this.view.ui.remove('zoom');
    this.getProject();

    this.map.on('load', function () {
      this.loading = false;
    });
  },
  methods: {
    addRainLayer(BaseDynamicLayer) {
      // 定義自訂的累積雨量圖動態圖層 (基於 BaseDynamicLayer)
      const RainfallLayer = BaseDynamicLayer.createSubclass({
        properties: {
          picUrl: null,
          extent: null,
          view: null,
          cSize: null,
          image: null,
          canvas: null,
        },
        // ESRI 在每次重新取圖時都會呼叫此方法
        getImageUrl(extent, width, height) {
          if (!this.image) {
            this.image = new Image();
          }
          this.image.setAttribute('crossOrigin', 'anonymous');
          this.image.src = this.picUrl;
          if (!this.canvas) {
            this.canvas = document.createElement('canvas');
          }
          this.canvas.width = this.cSize.width;
          this.canvas.height = this.cSize.height;
          
          // 計算畫布上圖片的繪製位置與大小
          const mapPoint = { x: this.extent.xmin, y: this.extent.ymax, spatialReference: { wkid: 4326 } };
          const screenPoint = this.view.toScreen(mapPoint);
          const leftBottom = { x: this.extent.xmin, y: this.extent.ymin, spatialReference: { wkid: 4326 } };
          const screenLeftBottom = this.view.toScreen(leftBottom);
          const rightTop = { x: this.extent.xmax, y: this.extent.ymax, spatialReference: { wkid: 4326 } };
          const screenRightTop = this.view.toScreen(rightTop);
          const ctx = this.canvas.getContext('2d');
          ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
          ctx.drawImage(
            this.image,
            screenPoint.x,
            screenPoint.y,
            Math.abs(screenRightTop.x - screenLeftBottom.x),
            Math.abs(screenRightTop.y - screenLeftBottom.y),
          );
          return this.canvas.toDataURL('image/png');
        },
      });
      
      // 累積雨量圖設定值
      const rainLayerConfig = {
        baseUrl: 'https://api-geoserver.geosupply.com.tw/rain/高鐵邊坡監測',
        extent: { 
          xmin: 119.77, 
          ymin: 21.746776427875963, 
          xmax: 122.67, 
          ymax: 25.449655229327627,
        },
        canvasSize: { width: 1347, height: 1888 },
      };
      
      // 建立累積雨量圖層 (預設 URL 為 24H)
      this.rainLayer = new RainfallLayer({
        title: '累積雨量圖',
        picUrl: `${rainLayerConfig.baseUrl}/HOUR_${this.selectedHour}.png`,
        extent: rainLayerConfig.extent,
        view: this.view,
        cSize: rainLayerConfig.canvasSize,
        visible: true,
      });
      
      // 加入地圖中
      this.map.add(this.rainLayer);
      this.rainLayer.refresh();
      // 為確保圖片更新，可在短延遲後再呼叫一次 refresh
      setTimeout(() => {
        this.rainLayer.refresh();
      }, 2000);
    },
    addMarker() {
      // 創建標記並加入地圖
      let graphics = [];
      this.locations.forEach(loc => {
        let url = this.greenMarkpic;
        if (loc.status === 'AL') {
          url = this.yellowMarkpic;
        } else if (loc.status === 'WSL') {
          url = this.redMarkpic;
        } else if (loc.status === 'down') {
          url = this.geryMarkpic;
        }
        let marker = new this.PictureMarkerSymbol({
          url,
          width: '13px',
          height: '13px',
        });

        let point = {
          type: 'point',
          longitude: loc.lon,
          latitude: loc.lat,
        };

        let pointGraphic = new this.Graphic({
          geometry: point,
          symbol: marker,
        });

        graphics.push(pointGraphic);
      });
      this.view.graphics.addMany(graphics);
    },
    getStatus(area) {
      if (!area.name.includes('邊坡')) {
        //console.log(area);
        this.locations.forEach(t => {
          if (area.name.includes(t.id)) {
            area.station.forEach(instruments => {
              let status = { AL: false, WSL: false };
              let total_count = 0;
              let down_count = 0;
              instruments.instrument.forEach(item => {
                total_count++;
                //console.log(item.status);
                if (item.status === 'AL') {
                  status.AL = true;
                } else if (item.status === 'WSL') {
                  status.WSL = true;
                } else if (item.status === 'down') {
                  down_count++;
                }
              });
              if (status.WSL) {
                t.status = 'WSL';
              } else if (status.AL) {
                t.status = 'AL';
              }
              if (total_count === down_count) {
                t.status = 'down';
              }
            });
          }
        });
      }
    },
    getProject() {
      this.resData.area.map(area => {
        this.getStatus(area);
      });
      this.addMarker();
    },
    captureScreenshot() {
      console.log('Map4Autoreport.vue: captureScreenshot() called');
      if (this.view) {
        return this.view.takeScreenshot().then((screenshot) => {
          // screenshot.data 是原始 ImageData
          // 在 4.14 沒有 toDataURL()，所以要手動轉

          const { data, width, height } = screenshot.data; // data 為 Uint8ClampedArray
          // 建立一個離線 canvas
          let canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;

          let ctx = canvas.getContext('2d');
          // 將 ArcGIS 回傳的 ImageData 寫入 canvas
          // putImageData 需要一個 ImageData 物件，所以要先用 ImageData() 包裝
          let imageDataObj = new ImageData(data, width, height);
          ctx.putImageData(imageDataObj, 0, 0);

          // 產生 Base64 字串
          let base64Image = canvas.toDataURL('image/png');
          console.log('Map4Autoreport.vue: screenshot success, base64:', base64Image);
          return base64Image;
        }).catch((error) => {
          console.error('Map4Autoreport.vue: screenshot error', error);
          return null;
        });
      } else {
        console.error('Map4Autoreport.vue: MapView is not ready');
        return Promise.resolve(null);
      }
    },
  },
};
</script>

<style scoped>
::v-deep .esri-view .esri-view-surface--inset-outline:focus::after {
  outline: auto 0px Highlight !important;
  outline: auto 0px -webkit-focus-ring-color !important;
}
</style>

<style scoped>
.container {
  width: 50%;
  height: 100vh;
  max-height: 750px;
}
</style>

<style>
.center-item {
  display: flex;
  align-items: center;
  padding-left: 2px;
}

.icon-text {
  padding-left: 5px;
  padding-right: 2px;
}

.esri-view .esri-view-surface--touch-none:focus::after {
  outline: none !important;
}
</style>